var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2001 12.9459V11.75C16.2001 11.3358 16.5359 11 16.9501 11H19.0501C19.4643 11 19.8001 11.3358 19.8001 11.75V12.9459",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 12.946L16.8 12.946",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2001 12.946H20.4001",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.1892V20.0811",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 16.8379L15.6 19.4325",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3999 16.8379L20.3999 19.4325",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 13.4768L13.6862 21.4487C13.7399 22.3202 14.4731 23 15.3615 23H20.3934C21.2623 23 21.9875 22.3488 22.0662 21.4983L22.8 13.4768M13.2 13.4768C12.4779 13.5263 12 13.5651 12 13.5651M13.2 13.4768C14.4683 13.3899 16.4902 13.2702 18 13.2702C19.5098 13.2702 21.5317 13.3899 22.8 13.4768M22.8 13.4768C23.5221 13.5263 24 13.5651 24 13.5651",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.23d302a0b879a1afdbe3ab253a560d4e.svg";
export { ForwardRef as ReactComponent };